import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import 'highlight.js/styles/github.css';

import { markdownComponents, MarkdownRefLink } from './markdownComponents';
import { IMessageMetadata } from '../../types/chat';
import Column from './core/Column';

interface MarkdownRendererProps {
  content: string;
  metadata?: IMessageMetadata
  id?: string
}

const stripFrontmatter = (content: string): string => {
  try{
    return content
    // Remove leading and trailing horizontal dividers if present (---, ***, ___)
    .replace(/^\s*([-*_]){3,}\s*\n?/, '')
    .replace(/\n?\s*([-*_]){3,}\s*$/, '')
    // Collapse consecutive dividers into one
    .replace(/(^|\n)[ \t]*([-*_]){3,}[ \t]*(\n[ \t]*([-*_]){3,}[ \t]*)+/g, '$1---');
  } catch {
    return content;
  }
};

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, metadata, id }) => {
  const formattedContent = stripFrontmatter(content);

  return (
    <Column sx={{ gridGap: '15px' }}>
      {/* Render Markdown with GitHub Flavored Markdown support */}
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeHighlight]}
        components={{
          ...markdownComponents,
          ref: (props: any) => <MarkdownRefLink {...props} metadata={metadata} />,
        } as any}
      >
        {formattedContent}
      </ReactMarkdown>
    </Column>
  );
};

export default MarkdownRenderer;
